// trigger rebuild
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import Kedai from "./pages/Kedai";
import KioskPanel from "./pages/KioskPanel";
import Admin from "./pages/Admin";
import Catalog from "./pages/Catalog";
import CatalogItem from "./pages/CatalogItem";
import Member from "./pages/Member";
import Requests from "./pages/Requests";
import StaffManage from "./pages/StaffManage";
import Warehouse from "./pages/Warehouse";
import IndukKedai from "./pages/IndukKedai";
import WarehousePortal from "./pages/WarehousePortal";
import { isWarehouseMode } from "./lib/warehouseMode";

function App() {
  if (isWarehouseMode()) {
    return (
      <div className="App">
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <WarehousePortal />
        </AuthProvider>
      </div>
    );
  }
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Navbar />
            <main className="min-h-[70vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/katalog" element={<Catalog />} />
                <Route path="/barang/:itemId" element={<CatalogItem />} />
                <Route path="/keranjang" element={<Cart />} />
                <Route path="/kedai" element={<Kedai />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/permintaan" element={<ProtectedRoute><Requests /></ProtectedRoute>} />
                <Route path="/member" element={<ProtectedRoute><Member /></ProtectedRoute>} />
                <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                <Route path="/pesanan" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
                <Route path="/pesanan/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
                <Route path="/kedai-panel" element={<ProtectedRoute role="agent"><KioskPanel /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
                <Route path="/kelola-akun" element={<ProtectedRoute role="owner"><StaffManage /></ProtectedRoute>} />
                <Route path="/gudang" element={<ProtectedRoute role={["gudang_china", "gudang_jakarta"]}><Warehouse /></ProtectedRoute>} />
                <Route path="/induk" element={<ProtectedRoute role="induk_kedai"><IndukKedai /></ProtectedRoute>} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
